<script setup lang="ts">
defineProps<{
  title?: string
}>()

defineEmits<{
  (event: 'close'): void
}>()
</script>

<template>
  <div class="flex w-full items-center justify-between p-4 md:p-6">
    <h3
      class="font-heading text-lg font-medium leading-6 text-muted-900 dark:text-white"
    >
      {{ title || 'Confirm action' }}
    </h3>

    <BaseButtonClose @click="$emit('close')" />
  </div>
</template>
